const style = {
  container: {
    border: `1px solid #ececec`
  },
  inputWrapper: {
    padding: 0,
    ':not(:first-of-type)': {
      borderLeft: `1px solid #ececec`
    }
  },
  input: {
    background: `white`,
    border: `none`,
    borderRadius: `3px`,
    borderBottom: `0px`,
    width: `100%`,
    padding: `5px 15px`,
    fontSize: `14px`,
    color: `#666`
  },
  select: {
    padding: `5px 15px`,
    width: `100%`,
    overflow: `hidden`,
    background: `#fff`,
    border: 0,
    borderRadius: `0px`,
    '-webkit-appearance': `none`,
    fontSize: `14px`
  },
  button: {
    width: `100%`
  }
}

export default style



// WEBPACK FOOTER //
// ./src/components/Community/Billing/Main/style/form.js